const HotelAmenitiesFilter = ['pornographic', 'Free Airport Shuttle'];

export default HotelAmenitiesFilter;
